import { PlusOutlined, ReloadOutlined } from "@ant-design/icons"
import { Button, Card, Select, Space, Tabs } from "antd"
import Title from "antd/es/typography/Title"
import React, { useRef, useState } from "react"
import { useNavigate } from "react-router"
import { t } from "~/languages/i18n"
import Filters, { FilterComponent } from "../../../components/Filters"
import { Paths } from "../../../constants"
import RecruitmentList from "./RecruitmentList"

const List: React.FC = () => {
  const [refreshKey, setRefreshKey] = useState(0)
  const [searchTerm, setSearchTerm] = useState("")
  const filterRef = useRef<{ filterFunction: () => void } | null>(null)
  const [defaultFilterValues, setDefaultFilterValues] = useState<{ [key: string]: any } | null>(null)
  const [filterValues, setFilterValues] = useState<{ [key: string]: string } | null>(null)

  const permissions = JSON.parse(localStorage.getItem("permissions") || "{}")
  const navigate = useNavigate()

  const handleRecruitmentAdded = () => {
    setRefreshKey(prevKey => prevKey + 1)
  }

  const handleSearch = () => {
    setRefreshKey(prevKey => prevKey + 1)
  }

  const onRefresh = () => {}

  return (
    <div className="p-4 ">
      <div className="flex space-x-4 items-center">
        <Title level={2} className="m-0">
          {t("Recruitment")}
        </Title>
        {permissions.post.create.enabled && (
          <Button
            onClick={() => navigate(Paths.RECRUITMENT.CREATE.PATH)}
            color="primary"
            variant="outlined"
            icon={<PlusOutlined />}
          >
            {t("Post Recruitment")}
          </Button>
        )}
      </div>
      <div className="flex justify-between mt-3">
        <Tabs
          defaultActiveKey="all"
          items={[
            { label: `${t("All")} ()`, key: "all" },
            { label: `${t("Draft")}`, key: "draft" },
            { label: `${t("Published")}`, key: "published" },
          ]}
        />
      </div>
      <div className="items-center">
        <Space className=" space-x-5 flex justify-between">
          <Space className="space-x-3">
            <Select
              defaultValue={t("Bulk Actions")}
              style={{ width: 170 }}
              options={[
                { value: "all", label: t("Bulk Actions") },
                ...(permissions.post.delete.enabled ? [{ value: "delete", label: t("Delete") }] : []),
              ]}
            />
            <Button>{t("Apply")}</Button>
          </Space>
          <Space>
            <Button onClick={onRefresh} icon={<ReloadOutlined />}>
              {t("Refresh")}
            </Button>
          </Space>
        </Space>
      </div>
      <Card type="inner" style={styles.card}>
        <Filters
          filterRef={filterRef}
          defaultFilterValues={defaultFilterValues}
          onSubmit={() => {}}
          filters={
            [
              {
                label: t("Recruitment Title"),
                placeholder: t("Find Recruitment Title"),
                name: "name",
                type: "text",
                customStyle: "2xl:w-[30rem] w-[20rem]",
              },
              {
                label: t("Department"),
                placeholder: t("Find Department"),
                name: "categories",
                type: "select-search",
              },
              {
                label: t("Form"),
                placeholder: t("Form"),
                name: "tags",
                type: "select-search",
              },
            ] as FilterComponent[]
          }
        />
      </Card>
      <RecruitmentList searchTerm={searchTerm} key={refreshKey} />
    </div>
  )
}

export default List

const styles = {
  title: {
    marginTop: 0,
    marginBottom: 0,
  },
  card: {
    marginTop: "1.25rem",
    marginBottom: "1.25rem",
  },
}
